import { graphql } from '../../gql';

export const GET_VAGO_SUBSCRIBERS = graphql(`
  query getVagoSubscribers($token: String!) {
    getVagoSubscribers(token: $token) {
      name
    }
  }
`);
